import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Historique from './Historique';
import withLoader from 'components/Shared/withLoader';
import { fetchReclamationHistoriqueIfNeeded } from 'store/reclamation/detailsActions';
import { invalidateReclamationHistorique } from 'store/reclamation/detailsActions';

import { deleteAction } from 'store/reclamation/reclamationsActions';

const HistoriqueWithLoader = withLoader(Historique);

class HistoriqueContainer extends React.Component {

    componentDidMount() {
        this.props.invalidateReclamationHistorique();
        this.props.fetchReclamationHistoriqueIfNeeded(this.props.reclamationId);
    }

    componentDidUpdate(prevProps) {

        if (this.props.scrollTo !== undefined && this.props.scrollTo) {

            const node = document.getElementById(this.props.scrollTo);

            if (node !== null) {
                node.scrollIntoView();
            }
        }

        if (prevProps.reclamationId !== this.props.reclamationId) {
            this.props.invalidateReclamationHistorique();
        }
        this.props.fetchReclamationHistoriqueIfNeeded(this.props.reclamationId);
    }


    handleClickRemoveAction = (actionId) => {
        this.props.deleteAction(actionId);
    }

    reloadHistory = () => {
        this.props.invalidateReclamationHistorique();
        this.props.fetchReclamationHistoriqueIfNeeded(this.props.reclamationId);
    }

    render() {

        let { reclamation, utilisateurCourant } = this.props;
               
        let utilisateurCourantAdminOuPiloteGroupe = utilisateurCourant.administrateur || (utilisateurCourant.groupes && utilisateurCourant.groupes.find(x => x.id === reclamation.affectationGroupe.id) && utilisateurCourant.groupes.find(x => x.id === reclamation.affectationGroupe.id).adminOuPilote);

        let utilisateurCourantMagasinier = utilisateurCourant && utilisateurCourant.groupes.find(x => x.code === 'MAGASIN') !== undefined;

        let utilisateurCourantAdmin = utilisateurCourant && utilisateurCourant.administrateur;
        let utilisateurCourantPiloteGroupeInterlocuteurSAV = utilisateurCourant
            && utilisateurCourant.groupes.find(x => x.code === 'INTERLOCUTEUR_SAV') !== undefined
            && utilisateurCourant.groupes.find(x => x.code === 'INTERLOCUTEUR_SAV').adminOuPilote;
        let utilisateurCourantDirecteurRegionalClient = utilisateurCourant && reclamation.client && reclamation.client.directeurRegional && utilisateurCourant.id === reclamation.client.directeurRegional.id;

        return (
            <HistoriqueWithLoader
                isLoading={this.props.isLoading}
                historique={this.props.historique}
                utilisateurCourantAdminOuPiloteGroupe={utilisateurCourantAdminOuPiloteGroupe}
                utilisateurCourantMagasinier={utilisateurCourantMagasinier}

                utilisateurCourantAdmin={utilisateurCourantAdmin}
                utilisateurCourantPiloteGroupeInterlocuteurSAV={utilisateurCourantPiloteGroupeInterlocuteurSAV}
                utilisateurCourantDirecteurRegionalClient={utilisateurCourantDirecteurRegionalClient}


                onClickRemoveAction={this.handleClickRemoveAction}

                reloadHistory={this.reloadHistory}
            />
        );
    }
}

HistoriqueContainer.propTypes = {
    reclamationId: PropTypes.number.isRequired,
    scrollTo: PropTypes.string
};

const mapStateToProps = state => ({
    isLoading: state.reclamation.details.isHistoriqueLoading,
    didInvalidate: state.reclamation.details.didHistoriqueInvalidate,
    historique: state.reclamation.details.historique,
    reclamation: state.reclamation.details.item,
    utilisateurCourant: JSON.parse(localStorage.getItem('utilisateur'))
});

const mapDispatchToProps = dispatch => ({
    fetchReclamationHistoriqueIfNeeded: id => dispatch(fetchReclamationHistoriqueIfNeeded(id)),
    invalidateReclamationHistorique: () => dispatch(invalidateReclamationHistorique()),
    deleteAction: actionId => dispatch(deleteAction(actionId))    
});

export default connect(mapStateToProps, mapDispatchToProps)(HistoriqueContainer);